module.exports = __webpack_public_path__ + "img/gift.3367711c.png";